import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { IService } from '../asp/interfaces';
import { PresetComponent, PresetWindowState } from './preset/preset.component';

@Injectable({
  providedIn: 'root'
})

export class PresetWindowService implements IService {
  private dialogRef: MatDialogRef<any>;

  constructor(private dialog: MatDialog) {
  }

  showWindow(state: PresetWindowState) {
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      let errorComp = this.dialogRef.componentInstance as PresetComponent;
      errorComp.dialogRaise();
    }
    else {
      this.dialogRef = this.dialog.open(PresetComponent, { ...PresetComponent.createDialogConfig(), data: { state }});
      let errorComp = this.dialogRef.componentInstance as PresetComponent;
      errorComp.dialogRaise();
    }
  }
}
